// extracted by mini-css-extract-plugin
module.exports = {"borderTop":"ErrorModal_borderTop__2ilSF","modalTitle":"ErrorModal_modalTitle__1QtUh","modalHeader":"ErrorModal_modalHeader__dmeEe","modalFooter":"ErrorModal_modalFooter__3MnXw"};